import styled from 'styled-components';
import { spacing, font, colors } from '@chegg-ui/theme';
export var Container = styled.div.withConfig({
  componentId: "sc-1w81iwp-0"
})(["display:flex;align-items:center;font-size:", ";line-height:", ";color:", ";margin-bottom:", ";&.error{color:", ";}.icon{margin-block-end:0.2rem;margin-inline-end:8px;}"], font.size.px14, font.lineHeight.md, colors.dark, spacing.px16, colors.errorRed);
export var FlexStartWrapper = styled.div.withConfig({
  componentId: "sc-1w81iwp-1"
})(["display:flex;align-items:flex-start;margin-block-start:", ";"], spacing.px12);